import { Card, CardBody, CardHeader, Flex, Heading, LinkBox, LinkOverlay } from '@homebotapp/hb-react-component-catalog'
import { useDispatch } from 'react-redux'
import { setIsShortcutsDrawerOpen } from '../../../store/slices/navigation'
import { NavigationShortcutDatum } from '../../../types/navigation'

export interface HubTileProps {
  variant?: 'wide'
  option: NavigationShortcutDatum
}

export const HubTile = ({ variant, option }: HubTileProps) => {
  const dispatch = useDispatch()

  const isWide = variant === 'wide'
  const isButton = !option.href && option.onClick

  const handleClick = e => {
    dispatch(setIsShortcutsDrawerOpen(false))

    if (option.onClick) {
      option.onClick(e)
    }
  }

  return (
    <LinkBox height='100%'>
      <Card
        onClick={handleClick}
        height='100%'
        role={isButton && 'button'}
        minW={isWide ? '9rem' : '5.70rem'}
        minH={isWide ? '108' : '112'}
        _focusWithin={{
          boxShadow: 'outline'
        }}
        _active={{
          bg: 'neutral.200'
        }}
        _hover={{
          bg: 'neutral.100'
        }}
      >
        <CardHeader
          backgroundColor='card-bg-layer-3'
          borderTopRightRadius='3%'
          borderTopLeftRadius='3%'
          py='3'
          _light={{
            bg: 'blackAlpha.50 !important'
          }}
        >
          <Flex justifyContent='center'>{option.icon}</Flex>
        </CardHeader>
        <CardBody px='2' py='2'>
          <LinkOverlay href={option.href || '#'} onClick={handleClick} tracking={option.tracking}>
            <Heading as='h3' size='xs' textAlign={isWide ? 'center' : 'left'} mb='0' marginY={isWide && '3'}>
              {option.body}
            </Heading>
          </LinkOverlay>
        </CardBody>
      </Card>
    </LinkBox>
  )
}
